// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"812":"5a40f59d","956":"032b9396"}[chunkId] + ".chunk.js";
};